// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TextField, FormControl, Select, makeStyles } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

// Internal Dependencies
import Colours from '../../../../../styles/colours';
import { GiftType, Status } from '../../../../../common/constants';
import { Trim } from '../../../../../common/util';
import MText from '../../../../../components/Common/MText';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
  halfWidth: {
    width: '50%',
  },
  w200: {
    width: '200px',
  },
  w250: {
    width: '250px',
  },
  bgWhite: {
    backgroundColor: Colours.White,
  },
}));

function FilterGift(props) {
  const classes = useStyles();

  const [status, setStatus] = useState('');
  const [type, setType] = useState('');

  const onDescriptionChange = (data) => {
    // to replace double whitespace before & after each word with ''
    const trimmedDescription = Trim(data);
    props.updateDescriptionFilter(trimmedDescription);
  };

  const debounceDescription = _.debounce(onDescriptionChange, 700);

  const onTypeChange = (data) => {
    setType(data);
    props.updateTypeFilter(data);
  };

  const onStatusChange = (data) => {
    setStatus(data);
    props.updateStatusFilter(data);
  };

  return (
    <div className={`mt-2 mb-2 ${isMobile ? `d-block px-3` : `d-flex flex-row justify-content-start`}`}>
      <div>
        <MText text="Name" size={13} />
        <TextField
          className={isMobile ? `mt-1 ${classes.fullWidth} ${classes.bgWhite}` : `mt-1 ${classes.w250} ${classes.bgWhite}`}
          variant="outlined"
          size="small"
          defaultValue=""
          multiline
          maxRows={8}
          inputProps={{
            'aria-label': 'naked',
            style:        {
              fontSize: 12,
            },
          }}
          onChange={(e) => debounceDescription(e.target.value)}
        />
      </div>

      <div className={isMobile ? `mt-3` : `ml-3`}>
        <MText text="Type" size={13} />
        <FormControl
          size="small"
          className={isMobile ? `${classes.fullWidth} mt-1` : `${classes.w200} mt-1`}
          variant="outlined"
        >
          <Select
            native
            value={type}
            onChange={(e) => onTypeChange(e.target.value)}
            className={classes.bgWhite}
            inputProps={{ style: { fontSize: 12, backgroundColor: Colours.White, paddingTop: '13px', paddingBottom: '13px' } }}
          >
            <option aria-label="None" value="">All</option>
            <option value={GiftType.Coupon}>Coupon</option>
            <option value={GiftType.Voucher}>Voucher</option>
          </Select>
        </FormControl>
      </div>

      <div className={isMobile ? `mt-3` : `ml-3`}>
        <MText text="Status" size={13} />
        <FormControl size="small" className={isMobile ? `${classes.fullWidth} mt-1` : `${classes.w200} mt-1`} variant="outlined">
          <Select
            native
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
            className={classes.bgWhite}
            inputProps={{ style: { fontSize: 12, backgroundColor: Colours.White, paddingTop: '13px', paddingBottom: '13px' } }}
          >
            <option aria-label="None" value="">All</option>
            <option value={Status.Draft}>Draft</option>
            <option value={Status.Activated}>Activated</option>
            <option value={Status.Deactivated}>Deactivated</option>
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

FilterGift.propTypes = {
  updateDescriptionFilter: PropTypes.func.isRequired,
  updateTypeFilter:        PropTypes.func.isRequired,
  updateStatusFilter:      PropTypes.func.isRequired,
};

export default FilterGift;
